module.exports = __webpack_public_path__ + "static/media/speaker1.a294c8bf.png";